<template>
  <div class="wrap-blog-item">
    <div class="block-news">
      <router-link :to="{name: 'blog', params: {'page': item.url, lang: $store.getters.getLang}}" class="news-img" :style="{'backgroundImage': 'url('+ item.img +')'}"/>
      <div class="news-text">
        <div class="news-text__head">
<!--            <span class="block-category" >{{categoryItem.category}}</span>-->
          <span class="block-category" @click="pushCategory">
            <router-link :to="{name: 'blogs_category', params: {'type': 'category', 'name': item.category, lang: $store.getters.getLang}}" >{{item.category}}</router-link>
          </span>
          <div class="d-flex align-center">
            <div class="block-views">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.8856 8.64983C17.7248 8.42986 13.8934 3.26367 8.99991 3.26367C4.10647 3.26367 0.274852 8.42986 0.114223 8.64962C-0.0380743 8.85831 -0.0380743 9.14135 0.114223 9.35004C0.274852 9.57001 4.10647 14.7362 8.99991 14.7362C13.8934 14.7362 17.7248 9.56998 17.8856 9.35022C18.0381 9.14156 18.0381 8.85831 17.8856 8.64983ZM8.99991 13.5494C5.39537 13.5494 2.27345 10.1205 1.3493 8.99953C2.27226 7.87759 5.38764 4.45048 8.99991 4.45048C12.6043 4.45048 15.726 7.87878 16.6505 9.00034C15.7276 10.1222 12.6122 13.5494 8.99991 13.5494Z" />
                <path d="M8.9999 5.43945C7.03671 5.43945 5.43945 7.03671 5.43945 8.99991C5.43945 10.9631 7.03671 12.5604 8.9999 12.5604C10.9631 12.5604 12.5603 10.9631 12.5603 8.99991C12.5603 7.03671 10.9631 5.43945 8.9999 5.43945ZM8.9999 11.3735C7.69103 11.3735 6.62629 10.3087 6.62629 8.99991C6.62629 7.69107 7.69107 6.62629 8.9999 6.62629C10.3087 6.62629 11.3735 7.69107 11.3735 8.99991C11.3735 10.3087 10.3088 11.3735 8.9999 11.3735Z" />
              </svg>
              <span>{{item.views}}</span>
            </div>

            <v-menu style="position: relative" open-on-hover offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                        v-bind="attrs"
                        v-on="on"
                        v-ripple="false"
                        text
                        class="btn-link">
                  <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 16H1C0.447 16 0 15.553 0 15.001V5C0 4.448 0.447 4 1 4H2.5V5H1.5C1.224 5 1 5.225 1 5.5V14.5C1 14.777 1.224 15.001 1.5 15.001H11.5C11.775 15.001 12 14.777 12 14.5V5.5C12 5.225 11.775 5 11.5 5H10.5V4H12C12.552 4 13 4.448 13 5V15.001C13 15.553 12.552 16 12 16ZM8.66602 3.35693L7 1.69092V11.5C7 11.776 6.775 12 6.5 12C6.224 12 6 11.776 6 11.5V1.69092L4.33301 3.35693C4.14301 3.54793 3.83294 3.54793 3.64294 3.35693C3.45294 3.16793 3.45294 2.85697 3.64294 2.66797L6.11304 0.196899C6.11604 0.192899 6.122 0.191012 6.125 0.187012C6.136 0.174012 6.13204 0.154968 6.14404 0.141968C6.16304 0.123968 6.18996 0.129967 6.20996 0.115967C6.28396 0.0559668 6.36995 0.0149346 6.47095 0.00793457C6.47895 0.00793457 6.48604 0.00292969 6.49304 0.00292969C6.49604 0.00292969 6.49798 0 6.50098 0C6.50398 0 6.50603 0.00192969 6.50903 0.00292969C6.51503 0.00192969 6.51902 0.00598145 6.52502 0.00598145C6.64402 0.0119814 6.75196 0.0589346 6.83496 0.132935C6.84196 0.139935 6.85301 0.136944 6.85901 0.142944C6.86501 0.150944 6.86202 0.161969 6.86902 0.167969C6.87302 0.171969 6.87198 0.179937 6.87598 0.184937L9.35803 2.66797C9.54903 2.85697 9.54903 3.16793 9.35803 3.35693C9.16603 3.54893 8.85702 3.54893 8.66602 3.35693Z" fill="currentColor"/>
                  </svg>
                </v-btn>
              </template>

              <v-list class="list-socials">

                <p>{{__('Share:')}}</p>
                <a   :href="'http://www.facebook.com/sharer.php?s=100&p[url]='+ $APP_URL + (($store.getters.getLang) ? '/' + $store.getters.getLang : '') + '/blog/' + item.url + '&p[title]=' + item.title + '&p[summary]=' + item.description" onclick="window.open(this.href, this.title, 'toolbar=0, status=0, width=548, height=325'); return false" title="Поделиться ссылкой на Фейсбук" target="_parent">
                  <v-list-item>
                    <v-list-item-title style="margin-left: 3px">
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.48194 17.9648H3.5994C3.11792 17.9648 2.72626 17.5732 2.72626 17.0917V10.59H1.04453C0.563049 10.59 0.171387 10.1982 0.171387 9.71686V6.93086C0.171387 6.44939 0.563049 6.05772 1.04453 6.05772H2.72626V4.6626C2.72626 3.27928 3.16063 2.10237 3.98227 1.25931C4.80762 0.412399 5.96105 -0.0351562 7.31786 -0.0351562L9.51622 -0.0315857C9.99687 -0.0307617 10.3878 0.360901 10.3878 0.841553V3.42828C10.3878 3.90976 9.99632 4.30142 9.51499 4.30142L8.03485 4.30197C7.58345 4.30197 7.46851 4.39247 7.44393 4.42021C7.40341 4.46622 7.35521 4.59627 7.35521 4.95538V6.05759H9.40375C9.55797 6.05759 9.70738 6.09563 9.83579 6.16731C10.1128 6.32208 10.285 6.61473 10.285 6.931L10.2839 9.717C10.2839 10.1982 9.89223 10.5899 9.41075 10.5899H7.35521V17.0917C7.35521 17.5732 6.96341 17.9648 6.48194 17.9648ZM3.78149 16.9096H6.29984V10.1176C6.29984 9.7961 6.56145 9.53462 6.8828 9.53462H9.22865L9.22962 7.11296H6.88266C6.56131 7.11296 6.29984 6.85149 6.29984 6.53V4.95538C6.29984 4.54312 6.34172 4.07428 6.65291 3.72189C7.02892 3.2959 7.62149 3.24673 8.03458 3.24673L9.33261 3.24619V1.02338L7.31703 1.02008C5.13652 1.02008 3.78149 2.41589 3.78149 4.6626V6.53C3.78149 6.85135 3.52002 7.11296 3.19867 7.11296H1.22662V9.53462H3.19867C3.52002 9.53462 3.78149 9.7961 3.78149 10.1176V16.9096ZM9.51416 1.02365H9.5143H9.51416Z" fill="currentColor"/>
                      </svg>

                      {{__('Facebook')}}
                    </v-list-item-title>
                  </v-list-item>
                </a>

<!--                <a :href="'https://plus.google.com/share?url=' + item.url" target="_blank" onclick="window.open(this.href, this.title, 'toolbar=0, status=0, width=548, height=325'); return false">-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-title>-->


<!--                      Google-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                </a>-->

                <a :href="'https://twitter.com/share?url=' + $APP_URL + (($store.getters.getLang) ? '/' + $store.getters.getLang : '') + '/blog/' + item.url + '&text=' + item.title " onclick="window.open(this.href, this.title, 'toolbar=0, status=0, width=548, height=325'); return false" target="_parent">
                  <v-list-item>
                    <v-list-item-title>
                      <svg width="20" height="16" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.50035 18.8126C4.37086 18.8129 2.27619 18.2724 0.412784 17.2416C0.304468 17.1813 0.219077 17.0869 0.169848 16.9732C0.120619 16.8594 0.110303 16.7325 0.140499 16.6123C0.170694 16.492 0.239714 16.3851 0.33686 16.3081C0.434006 16.231 0.55385 16.1882 0.677815 16.1862C2.63797 16.1589 4.55786 15.6259 6.25153 14.6388C4.29883 13.1061 2.84313 11.0301 2.06763 8.67201C1.29214 6.31392 1.23151 3.77911 1.89338 1.38663C1.92232 1.2823 1.98075 1.18854 2.06166 1.1166C2.14258 1.04466 2.24253 0.997597 2.34954 0.981067C2.45654 0.964537 2.56604 0.979238 2.66489 1.02341C2.76374 1.06758 2.84774 1.13934 2.90682 1.23007C3.75292 2.5367 4.85749 3.65633 6.15255 4.52004C7.44761 5.38374 8.90575 5.97325 10.4372 6.25226C10.4363 6.21682 10.4359 6.18135 10.4359 6.14585C10.4359 5.22231 10.7324 4.32318 11.2818 3.58077C11.8311 2.83837 12.6042 2.29192 13.4874 2.02183C14.3706 1.75175 15.3171 1.7723 16.1877 2.08046C17.0583 2.38862 17.807 2.96812 18.3236 3.73367C19.3444 3.6747 20.3526 3.4797 21.3218 3.15382C21.434 3.11613 21.5553 3.11483 21.6683 3.1501C21.7814 3.18537 21.8804 3.25541 21.9513 3.35025C22.0222 3.44509 22.0614 3.55989 22.0632 3.67829C22.0651 3.7967 22.0295 3.91266 21.9616 4.00967C21.1611 5.15611 20.1742 6.16041 19.0419 6.98088C18.8553 10.1807 17.4527 13.1883 15.1212 15.3878C12.7897 17.5873 9.70564 18.8125 6.50035 18.8126ZM2.85357 17.0923C4.02905 17.4863 5.26058 17.6874 6.50035 17.6876C9.4627 17.6876 12.3095 16.5382 14.4415 14.4814C16.5734 12.4247 17.8243 9.62098 17.9306 6.66054C17.9337 6.5729 17.9573 6.48719 17.9994 6.41026C18.0415 6.33333 18.101 6.26732 18.1732 6.21748C18.83 5.76412 19.4371 5.2427 19.9844 4.66188C19.3412 4.78251 18.6896 4.85281 18.0354 4.87217C17.93 4.87506 17.8258 4.84835 17.7348 4.79506C17.6437 4.74177 17.5694 4.66404 17.5203 4.57067C17.1448 3.91181 16.5469 3.40832 15.8337 3.15055C15.1205 2.89278 14.3389 2.89759 13.6289 3.16413C12.919 3.43067 12.3273 3.94148 11.96 4.60491C11.5927 5.26834 11.4738 6.04095 11.6247 6.7841C11.6463 6.87335 11.6457 6.96651 11.623 7.05548C11.6003 7.14444 11.5562 7.2265 11.4945 7.29451C11.4328 7.36252 11.3555 7.41442 11.2691 7.44567C11.1828 7.47692 11.0901 7.48659 10.9992 7.47382C7.74245 7.08756 4.76757 5.43794 2.715 2.88007C2.36034 5.0344 2.62863 7.2452 3.48827 9.25217C4.34791 11.2591 5.76311 12.9787 7.56722 14.2084C7.64294 14.26 7.7049 14.3293 7.74772 14.4103C7.79055 14.4913 7.81293 14.5815 7.81293 14.6732C7.81293 14.7648 7.79055 14.855 7.74772 14.936C7.7049 15.0171 7.64294 15.0864 7.56722 15.138C6.14724 16.1069 4.54249 16.7722 2.85347 17.0923H2.85357Z" fill="currentColor"/>
                      </svg>


                      {{__('Twitter')}}
                    </v-list-item-title>
                  </v-list-item>
                </a>

                <a  :href="'https://www.linkedin.com/cws/share?url=' + $APP_URL + (($store.getters.getLang) ? '/' + $store.getters.getLang : '') + '/blog/' + item.url" onclick="window.open(this.href, this.title, 'toolbar=0, status=0, width=548, height=325'); return false" target="_parent">
                  <v-list-item>
                    <v-list-item-title>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.8014 0.833344H2.19858C1.83662 0.833756 1.4896 0.977727 1.23366 1.23367C0.977712 1.48962 0.833741 1.83663 0.833328 2.19859V17.8014C0.833741 18.1634 0.977712 18.5104 1.23366 18.7664C1.4896 19.0223 1.83662 19.1663 2.19858 19.1667H17.8014C18.1634 19.1663 18.5104 19.0223 18.7663 18.7664C19.0223 18.5104 19.1663 18.1634 19.1667 17.8014V2.19859C19.1663 1.83663 19.0223 1.48962 18.7663 1.23367C18.5104 0.977727 18.1634 0.833756 17.8014 0.833344ZM17.9965 17.8014C17.9964 17.8531 17.9758 17.9027 17.9393 17.9393C17.9027 17.9759 17.8531 17.9964 17.8014 17.9965H2.19858C2.14687 17.9964 2.09729 17.9759 2.06072 17.9393C2.02416 17.9027 2.00359 17.8531 2.00354 17.8014V2.19859C2.00359 2.14688 2.02416 2.0973 2.06072 2.06074C2.09729 2.02417 2.14687 2.00361 2.19858 2.00356H17.8014C17.8531 2.00361 17.9027 2.02417 17.9393 2.06074C17.9758 2.0973 17.9964 2.14688 17.9965 2.19859V17.8014ZM6.68439 8.43983V14.681C6.68439 14.8361 6.62275 14.985 6.51302 15.0947C6.40329 15.2044 6.25447 15.2661 6.09929 15.2661C5.94411 15.2661 5.79528 15.2044 5.68555 15.0947C5.57582 14.985 5.51418 14.8361 5.51418 14.681V8.43983C5.51418 8.28465 5.57582 8.13582 5.68555 8.02609C5.79528 7.91636 5.94411 7.85472 6.09929 7.85472C6.25447 7.85472 6.40329 7.91636 6.51302 8.02609C6.62275 8.13582 6.68439 8.28465 6.68439 8.43983ZM15.266 11.1703V14.681C15.266 14.8361 15.2043 14.985 15.0946 15.0947C14.9849 15.2044 14.836 15.2661 14.6808 15.2661C14.5257 15.2661 14.3768 15.2044 14.2671 15.0947C14.1574 14.985 14.0957 14.8361 14.0957 14.681V11.1703C14.0957 10.6013 13.8697 10.0556 13.4674 9.6533C13.065 9.25096 12.5193 9.02493 11.9503 9.02493C11.3814 9.02493 10.8357 9.25096 10.4333 9.6533C10.031 10.0556 9.80496 10.6013 9.80496 11.1703V14.681C9.80496 14.8361 9.74331 14.985 9.63359 15.0947C9.52386 15.2044 9.37503 15.2661 9.21985 15.2661C9.06467 15.2661 8.91585 15.2044 8.80612 15.0947C8.69639 14.985 8.63475 14.8361 8.63475 14.681V8.43983C8.63475 8.28465 8.69639 8.13582 8.80612 8.02609C8.91585 7.91636 9.06467 7.85472 9.21985 7.85472C9.37503 7.85472 9.52386 7.91636 9.63359 8.02609C9.74331 8.13582 9.80496 8.28465 9.80496 8.43983V8.6453C10.2868 8.23496 10.8762 7.97125 11.5032 7.88535C12.1303 7.79945 12.7688 7.89496 13.3433 8.16059C13.9178 8.42621 14.4042 8.85083 14.7449 9.38421C15.0856 9.91759 15.2664 10.5374 15.266 11.1703ZM7.07446 5.31916C7.07446 5.51203 7.01727 5.70057 6.91012 5.86094C6.80296 6.02131 6.65066 6.1463 6.47247 6.22011C6.29428 6.29391 6.0982 6.31323 5.90904 6.2756C5.71987 6.23797 5.54611 6.1451 5.40973 6.00871C5.27335 5.87233 5.18047 5.69857 5.14285 5.50941C5.10522 5.32024 5.12453 5.12417 5.19834 4.94598C5.27215 4.76779 5.39714 4.61548 5.55751 4.50833C5.71787 4.40118 5.90641 4.34398 6.09929 4.34398C6.35783 4.34427 6.60571 4.4471 6.78853 4.62992C6.97135 4.81274 7.07418 5.06061 7.07446 5.31916Z" fill="currentColor"/>
                      </svg>

                      {{__('Linkedin')}}
                    </v-list-item-title>
                  </v-list-item>
                </a>

                <a  :href="'https://vk.com/share.php?url=' + $APP_URL + (($store.getters.getLang) ? '/' + $store.getters.getLang : '') + '/blog/' + item.url" onclick="window.open(this.href, this.title, 'toolbar=0, status=0, width=548, height=325'); return false" target="_parent">
                  <v-list-item>
                    <v-list-item-title>
                      <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="-0.999924" y="-0.831787" width="22" height="13" fill="black">
                          <rect fill="white" x="-0.999924" y="-0.831787" width="22" height="13"/>
                          <path d="M19.1114 9.11255C18.6763 8.59118 18.1849 8.12567 17.7095 7.67547C17.5425 7.51723 17.3697 7.35359 17.2033 7.19113C17.2032 7.19109 17.2032 7.19105 17.2031 7.19101C16.9793 6.97269 16.8697 6.81773 16.8583 6.70328C16.847 6.59078 16.9239 6.42386 17.1008 6.17714C17.3652 5.80605 17.647 5.43433 17.9197 5.07487C18.162 4.75534 18.4126 4.42491 18.6527 4.0926L18.7066 4.01799C19.1752 3.36948 19.6596 2.69889 19.9192 1.8817C19.9934 1.6474 20.0704 1.30068 19.8847 0.996302C19.6989 0.691848 19.3545 0.601613 19.1117 0.560285C18.9932 0.539972 18.8807 0.538292 18.776 0.538292L15.7367 0.535597C15.2112 0.526847 14.8467 0.77591 14.648 1.27607C14.489 1.67552 14.3013 2.13845 14.0837 2.5776C13.6675 3.42537 13.1386 4.40182 12.3721 5.21538L12.338 5.25163C12.2858 5.30733 12.2005 5.39843 12.1568 5.41933C12.0737 5.36714 11.9779 5.06866 11.9823 4.91229C11.9824 4.90843 11.9824 4.9046 11.9824 4.90077L11.9797 1.38892C11.9797 1.37107 11.9785 1.35322 11.9761 1.33552C11.9079 0.834504 11.775 0.332237 10.9821 0.175752C10.9566 0.170713 10.9308 0.168213 10.9049 0.168213H7.74339C7.14858 0.168213 6.83397 0.440597 6.58174 0.73591C6.50874 0.822004 6.31475 1.0506 6.41358 1.33005C6.51358 1.61283 6.81155 1.66927 6.90936 1.68779C7.25389 1.75318 7.43206 1.94791 7.48722 2.32017C7.59624 3.0435 7.6096 3.81729 7.52933 4.75413C7.50694 5.00565 7.4653 5.19683 7.39811 5.35581C7.37952 5.39984 7.36319 5.4271 7.35179 5.44316C7.33358 5.43581 7.30526 5.42175 7.26604 5.39491C7.02393 5.22925 6.84147 4.97171 6.66503 4.72272C5.96026 3.72768 5.36744 2.62869 4.85248 1.36248C4.64041 0.843606 4.24174 0.5538 3.73064 0.5463C2.75689 0.530089 1.8563 0.53048 0.978332 0.54755C0.564229 0.554738 0.273838 0.68509 0.115088 0.935052C-0.043858 1.18548 -0.0380377 1.50478 0.132431 1.88423C1.35103 4.59401 2.45752 6.56527 3.72002 8.27598C4.60897 9.48036 5.50381 10.3164 6.53612 10.907C7.62073 11.5275 8.84394 11.8316 10.263 11.8316C10.4244 11.8316 10.5886 11.8276 10.7549 11.8197C11.6304 11.7798 11.9866 11.4316 12.0255 10.5789C12.0473 10.1282 12.0975 9.76313 12.2715 9.44594C12.3202 9.35715 12.3751 9.29762 12.4184 9.28673C12.4644 9.27524 12.546 9.3034 12.6367 9.36235C12.8026 9.47009 12.9455 9.61618 13.0629 9.74442C13.182 9.87477 13.3023 10.0094 13.4188 10.1396C13.6665 10.4168 13.9227 10.7035 14.1912 10.977C14.7983 11.5959 15.4983 11.8797 16.2724 11.8203L19.0538 11.8215C19.0539 11.8215 19.0539 11.8215 19.054 11.8215C19.0628 11.8215 19.0716 11.8213 19.0804 11.8207C19.4013 11.7993 19.6787 11.6217 19.8415 11.3333C20.0377 10.9859 20.0347 10.5459 19.8335 10.1559C19.6235 9.7504 19.351 9.40137 19.1114 9.11255ZM19.1478 10.9415C19.1094 11.0094 19.0621 11.0218 19.0377 11.0248L16.2568 11.0235C16.2567 11.0235 16.2567 11.0235 16.2565 11.0235C16.2456 11.0235 16.2346 11.0239 16.2237 11.0249C15.6758 11.0705 15.2102 10.8779 14.7599 10.4189C14.5044 10.1587 14.2545 9.87911 14.0128 9.60872C13.895 9.47696 13.7733 9.34067 13.6509 9.20676C13.4992 9.04106 13.3117 8.85063 13.0707 8.69414C12.7099 8.45996 12.4109 8.46704 12.2237 8.51422C12.0384 8.5609 11.7751 8.69411 11.5729 9.06301C11.3111 9.54032 11.2533 10.0552 11.2298 10.5417C11.2162 10.8392 11.1659 10.9178 11.1448 10.9377C11.1173 10.9639 11.0253 11.0099 10.7182 11.024C9.24257 11.0933 8.00421 10.8291 6.93182 10.2155C5.99893 9.68177 5.18205 8.91508 4.36115 7.80293C3.13361 6.13968 2.05353 4.21358 0.859191 1.55771C0.81591 1.4615 0.80255 1.40146 0.798683 1.36931C0.829152 1.35931 0.888683 1.34615 0.993059 1.34423C1.86212 1.3274 2.7533 1.32693 3.71826 1.34302C3.85037 1.34498 4.0008 1.38462 4.11471 1.66334C4.65276 2.98635 5.27428 4.13772 6.01491 5.18335C6.21155 5.46089 6.45632 5.80636 6.81604 6.05249C7.14554 6.27812 7.41292 6.26734 7.57925 6.21859C7.74565 6.1698 7.97659 6.03425 8.13214 5.66597C8.23249 5.42859 8.29315 5.16128 8.32319 4.82354C8.40901 3.82147 8.39378 2.98834 8.27534 2.20252C8.19187 1.63951 7.90116 1.23279 7.44323 1.02509C7.52456 0.982747 7.6162 0.965091 7.74347 0.965091H10.8637C11.0392 1.00447 11.074 1.05072 11.0859 1.06654C11.1364 1.13376 11.1653 1.29279 11.183 1.41705L11.1857 4.89651C11.1786 5.23007 11.3407 5.96984 11.8927 6.17269C11.8972 6.17437 11.9018 6.17593 11.9064 6.17742C12.4089 6.34164 12.7413 5.98691 12.9197 5.79632L12.9515 5.76249C13.7912 4.87128 14.3566 3.82995 14.7984 2.93014C15.0286 2.46549 15.2236 1.98486 15.3885 1.57056C15.471 1.36279 15.5461 1.32857 15.7252 1.33236C15.7277 1.33244 15.7301 1.33244 15.7326 1.33244L18.7758 1.33513C18.8465 1.33513 18.9204 1.33595 18.9777 1.34576C19.1227 1.37044 19.1824 1.40052 19.2021 1.41298C19.2042 1.43607 19.2037 1.50248 19.1599 1.64107C18.9391 2.33596 18.5125 2.92635 18.0609 3.55143L18.007 3.62616C17.7723 3.95084 17.5245 4.27753 17.285 4.5935C17.0088 4.95761 16.7233 5.33405 16.4527 5.71398C15.874 6.52136 15.9249 7.05715 16.647 7.76152C16.8177 7.92813 16.9926 8.09383 17.1618 8.25407C17.6415 8.70848 18.0947 9.13766 18.4991 9.62227C18.7108 9.87751 18.9508 10.184 19.1258 10.5218C19.217 10.6987 19.1946 10.8585 19.1478 10.9415Z"/>
                        </mask>
                        <path d="M19.1114 9.11255C18.6763 8.59118 18.1849 8.12567 17.7095 7.67547C17.5425 7.51723 17.3697 7.35359 17.2033 7.19113C17.2032 7.19109 17.2032 7.19105 17.2031 7.19101C16.9793 6.97269 16.8697 6.81773 16.8583 6.70328C16.847 6.59078 16.9239 6.42386 17.1008 6.17714C17.3652 5.80605 17.647 5.43433 17.9197 5.07487C18.162 4.75534 18.4126 4.42491 18.6527 4.0926L18.7066 4.01799C19.1752 3.36948 19.6596 2.69889 19.9192 1.8817C19.9934 1.6474 20.0704 1.30068 19.8847 0.996302C19.6989 0.691848 19.3545 0.601613 19.1117 0.560285C18.9932 0.539972 18.8807 0.538292 18.776 0.538292L15.7367 0.535597C15.2112 0.526847 14.8467 0.77591 14.648 1.27607C14.489 1.67552 14.3013 2.13845 14.0837 2.5776C13.6675 3.42537 13.1386 4.40182 12.3721 5.21538L12.338 5.25163C12.2858 5.30733 12.2005 5.39843 12.1568 5.41933C12.0737 5.36714 11.9779 5.06866 11.9823 4.91229C11.9824 4.90843 11.9824 4.9046 11.9824 4.90077L11.9797 1.38892C11.9797 1.37107 11.9785 1.35322 11.9761 1.33552C11.9079 0.834504 11.775 0.332237 10.9821 0.175752C10.9566 0.170713 10.9308 0.168213 10.9049 0.168213H7.74339C7.14858 0.168213 6.83397 0.440597 6.58174 0.73591C6.50874 0.822004 6.31475 1.0506 6.41358 1.33005C6.51358 1.61283 6.81155 1.66927 6.90936 1.68779C7.25389 1.75318 7.43206 1.94791 7.48722 2.32017C7.59624 3.0435 7.6096 3.81729 7.52933 4.75413C7.50694 5.00565 7.4653 5.19683 7.39811 5.35581C7.37952 5.39984 7.36319 5.4271 7.35179 5.44316C7.33358 5.43581 7.30526 5.42175 7.26604 5.39491C7.02393 5.22925 6.84147 4.97171 6.66503 4.72272C5.96026 3.72768 5.36744 2.62869 4.85248 1.36248C4.64041 0.843606 4.24174 0.5538 3.73064 0.5463C2.75689 0.530089 1.8563 0.53048 0.978332 0.54755C0.564229 0.554738 0.273838 0.68509 0.115088 0.935052C-0.043858 1.18548 -0.0380377 1.50478 0.132431 1.88423C1.35103 4.59401 2.45752 6.56527 3.72002 8.27598C4.60897 9.48036 5.50381 10.3164 6.53612 10.907C7.62073 11.5275 8.84394 11.8316 10.263 11.8316C10.4244 11.8316 10.5886 11.8276 10.7549 11.8197C11.6304 11.7798 11.9866 11.4316 12.0255 10.5789C12.0473 10.1282 12.0975 9.76313 12.2715 9.44594C12.3202 9.35715 12.3751 9.29762 12.4184 9.28673C12.4644 9.27524 12.546 9.3034 12.6367 9.36235C12.8026 9.47009 12.9455 9.61618 13.0629 9.74442C13.182 9.87477 13.3023 10.0094 13.4188 10.1396C13.6665 10.4168 13.9227 10.7035 14.1912 10.977C14.7983 11.5959 15.4983 11.8797 16.2724 11.8203L19.0538 11.8215C19.0539 11.8215 19.0539 11.8215 19.054 11.8215C19.0628 11.8215 19.0716 11.8213 19.0804 11.8207C19.4013 11.7993 19.6787 11.6217 19.8415 11.3333C20.0377 10.9859 20.0347 10.5459 19.8335 10.1559C19.6235 9.7504 19.351 9.40137 19.1114 9.11255ZM19.1478 10.9415C19.1094 11.0094 19.0621 11.0218 19.0377 11.0248L16.2568 11.0235C16.2567 11.0235 16.2567 11.0235 16.2565 11.0235C16.2456 11.0235 16.2346 11.0239 16.2237 11.0249C15.6758 11.0705 15.2102 10.8779 14.7599 10.4189C14.5044 10.1587 14.2545 9.87911 14.0128 9.60872C13.895 9.47696 13.7733 9.34067 13.6509 9.20676C13.4992 9.04106 13.3117 8.85063 13.0707 8.69414C12.7099 8.45996 12.4109 8.46704 12.2237 8.51422C12.0384 8.5609 11.7751 8.69411 11.5729 9.06301C11.3111 9.54032 11.2533 10.0552 11.2298 10.5417C11.2162 10.8392 11.1659 10.9178 11.1448 10.9377C11.1173 10.9639 11.0253 11.0099 10.7182 11.024C9.24257 11.0933 8.00421 10.8291 6.93182 10.2155C5.99893 9.68177 5.18205 8.91508 4.36115 7.80293C3.13361 6.13968 2.05353 4.21358 0.859191 1.55771C0.81591 1.4615 0.80255 1.40146 0.798683 1.36931C0.829152 1.35931 0.888683 1.34615 0.993059 1.34423C1.86212 1.3274 2.7533 1.32693 3.71826 1.34302C3.85037 1.34498 4.0008 1.38462 4.11471 1.66334C4.65276 2.98635 5.27428 4.13772 6.01491 5.18335C6.21155 5.46089 6.45632 5.80636 6.81604 6.05249C7.14554 6.27812 7.41292 6.26734 7.57925 6.21859C7.74565 6.1698 7.97659 6.03425 8.13214 5.66597C8.23249 5.42859 8.29315 5.16128 8.32319 4.82354C8.40901 3.82147 8.39378 2.98834 8.27534 2.20252C8.19187 1.63951 7.90116 1.23279 7.44323 1.02509C7.52456 0.982747 7.6162 0.965091 7.74347 0.965091H10.8637C11.0392 1.00447 11.074 1.05072 11.0859 1.06654C11.1364 1.13376 11.1653 1.29279 11.183 1.41705L11.1857 4.89651C11.1786 5.23007 11.3407 5.96984 11.8927 6.17269C11.8972 6.17437 11.9018 6.17593 11.9064 6.17742C12.4089 6.34164 12.7413 5.98691 12.9197 5.79632L12.9515 5.76249C13.7912 4.87128 14.3566 3.82995 14.7984 2.93014C15.0286 2.46549 15.2236 1.98486 15.3885 1.57056C15.471 1.36279 15.5461 1.32857 15.7252 1.33236C15.7277 1.33244 15.7301 1.33244 15.7326 1.33244L18.7758 1.33513C18.8465 1.33513 18.9204 1.33595 18.9777 1.34576C19.1227 1.37044 19.1824 1.40052 19.2021 1.41298C19.2042 1.43607 19.2037 1.50248 19.1599 1.64107C18.9391 2.33596 18.5125 2.92635 18.0609 3.55143L18.007 3.62616C17.7723 3.95084 17.5245 4.27753 17.285 4.5935C17.0088 4.95761 16.7233 5.33405 16.4527 5.71398C15.874 6.52136 15.9249 7.05715 16.647 7.76152C16.8177 7.92813 16.9926 8.09383 17.1618 8.25407C17.6415 8.70848 18.0947 9.13766 18.4991 9.62227C18.7108 9.87751 18.9508 10.184 19.1258 10.5218C19.217 10.6987 19.1946 10.8585 19.1478 10.9415Z" fill="currentColor"/>
                        <path d="M19.1114 9.11255C18.6763 8.59118 18.1849 8.12567 17.7095 7.67547C17.5425 7.51723 17.3697 7.35359 17.2033 7.19113C17.2032 7.19109 17.2032 7.19105 17.2031 7.19101C16.9793 6.97269 16.8697 6.81773 16.8583 6.70328C16.847 6.59078 16.9239 6.42386 17.1008 6.17714C17.3652 5.80605 17.647 5.43433 17.9197 5.07487C18.162 4.75534 18.4126 4.42491 18.6527 4.0926L18.7066 4.01799C19.1752 3.36948 19.6596 2.69889 19.9192 1.8817C19.9934 1.6474 20.0704 1.30068 19.8847 0.996302C19.6989 0.691848 19.3545 0.601613 19.1117 0.560285C18.9932 0.539972 18.8807 0.538292 18.776 0.538292L15.7367 0.535597C15.2112 0.526847 14.8467 0.77591 14.648 1.27607C14.489 1.67552 14.3013 2.13845 14.0837 2.5776C13.6675 3.42537 13.1386 4.40182 12.3721 5.21538L12.338 5.25163C12.2858 5.30733 12.2005 5.39843 12.1568 5.41933C12.0737 5.36714 11.9779 5.06866 11.9823 4.91229C11.9824 4.90843 11.9824 4.9046 11.9824 4.90077L11.9797 1.38892C11.9797 1.37107 11.9785 1.35322 11.9761 1.33552C11.9079 0.834504 11.775 0.332237 10.9821 0.175752C10.9566 0.170713 10.9308 0.168213 10.9049 0.168213H7.74339C7.14858 0.168213 6.83397 0.440597 6.58174 0.73591C6.50874 0.822004 6.31475 1.0506 6.41358 1.33005C6.51358 1.61283 6.81155 1.66927 6.90936 1.68779C7.25389 1.75318 7.43206 1.94791 7.48722 2.32017C7.59624 3.0435 7.6096 3.81729 7.52933 4.75413C7.50694 5.00565 7.4653 5.19683 7.39811 5.35581C7.37952 5.39984 7.36319 5.4271 7.35179 5.44316C7.33358 5.43581 7.30526 5.42175 7.26604 5.39491C7.02393 5.22925 6.84147 4.97171 6.66503 4.72272C5.96026 3.72768 5.36744 2.62869 4.85248 1.36248C4.64041 0.843606 4.24174 0.5538 3.73064 0.5463C2.75689 0.530089 1.8563 0.53048 0.978332 0.54755C0.564229 0.554738 0.273838 0.68509 0.115088 0.935052C-0.043858 1.18548 -0.0380377 1.50478 0.132431 1.88423C1.35103 4.59401 2.45752 6.56527 3.72002 8.27598C4.60897 9.48036 5.50381 10.3164 6.53612 10.907C7.62073 11.5275 8.84394 11.8316 10.263 11.8316C10.4244 11.8316 10.5886 11.8276 10.7549 11.8197C11.6304 11.7798 11.9866 11.4316 12.0255 10.5789C12.0473 10.1282 12.0975 9.76313 12.2715 9.44594C12.3202 9.35715 12.3751 9.29762 12.4184 9.28673C12.4644 9.27524 12.546 9.3034 12.6367 9.36235C12.8026 9.47009 12.9455 9.61618 13.0629 9.74442C13.182 9.87477 13.3023 10.0094 13.4188 10.1396C13.6665 10.4168 13.9227 10.7035 14.1912 10.977C14.7983 11.5959 15.4983 11.8797 16.2724 11.8203L19.0538 11.8215C19.0539 11.8215 19.0539 11.8215 19.054 11.8215C19.0628 11.8215 19.0716 11.8213 19.0804 11.8207C19.4013 11.7993 19.6787 11.6217 19.8415 11.3333C20.0377 10.9859 20.0347 10.5459 19.8335 10.1559C19.6235 9.7504 19.351 9.40137 19.1114 9.11255ZM19.1478 10.9415C19.1094 11.0094 19.0621 11.0218 19.0377 11.0248L16.2568 11.0235C16.2567 11.0235 16.2567 11.0235 16.2565 11.0235C16.2456 11.0235 16.2346 11.0239 16.2237 11.0249C15.6758 11.0705 15.2102 10.8779 14.7599 10.4189C14.5044 10.1587 14.2545 9.87911 14.0128 9.60872C13.895 9.47696 13.7733 9.34067 13.6509 9.20676C13.4992 9.04106 13.3117 8.85063 13.0707 8.69414C12.7099 8.45996 12.4109 8.46704 12.2237 8.51422C12.0384 8.5609 11.7751 8.69411 11.5729 9.06301C11.3111 9.54032 11.2533 10.0552 11.2298 10.5417C11.2162 10.8392 11.1659 10.9178 11.1448 10.9377C11.1173 10.9639 11.0253 11.0099 10.7182 11.024C9.24257 11.0933 8.00421 10.8291 6.93182 10.2155C5.99893 9.68177 5.18205 8.91508 4.36115 7.80293C3.13361 6.13968 2.05353 4.21358 0.859191 1.55771C0.81591 1.4615 0.80255 1.40146 0.798683 1.36931C0.829152 1.35931 0.888683 1.34615 0.993059 1.34423C1.86212 1.3274 2.7533 1.32693 3.71826 1.34302C3.85037 1.34498 4.0008 1.38462 4.11471 1.66334C4.65276 2.98635 5.27428 4.13772 6.01491 5.18335C6.21155 5.46089 6.45632 5.80636 6.81604 6.05249C7.14554 6.27812 7.41292 6.26734 7.57925 6.21859C7.74565 6.1698 7.97659 6.03425 8.13214 5.66597C8.23249 5.42859 8.29315 5.16128 8.32319 4.82354C8.40901 3.82147 8.39378 2.98834 8.27534 2.20252C8.19187 1.63951 7.90116 1.23279 7.44323 1.02509C7.52456 0.982747 7.6162 0.965091 7.74347 0.965091H10.8637C11.0392 1.00447 11.074 1.05072 11.0859 1.06654C11.1364 1.13376 11.1653 1.29279 11.183 1.41705L11.1857 4.89651C11.1786 5.23007 11.3407 5.96984 11.8927 6.17269C11.8972 6.17437 11.9018 6.17593 11.9064 6.17742C12.4089 6.34164 12.7413 5.98691 12.9197 5.79632L12.9515 5.76249C13.7912 4.87128 14.3566 3.82995 14.7984 2.93014C15.0286 2.46549 15.2236 1.98486 15.3885 1.57056C15.471 1.36279 15.5461 1.32857 15.7252 1.33236C15.7277 1.33244 15.7301 1.33244 15.7326 1.33244L18.7758 1.33513C18.8465 1.33513 18.9204 1.33595 18.9777 1.34576C19.1227 1.37044 19.1824 1.40052 19.2021 1.41298C19.2042 1.43607 19.2037 1.50248 19.1599 1.64107C18.9391 2.33596 18.5125 2.92635 18.0609 3.55143L18.007 3.62616C17.7723 3.95084 17.5245 4.27753 17.285 4.5935C17.0088 4.95761 16.7233 5.33405 16.4527 5.71398C15.874 6.52136 15.9249 7.05715 16.647 7.76152C16.8177 7.92813 16.9926 8.09383 17.1618 8.25407C17.6415 8.70848 18.0947 9.13766 18.4991 9.62227C18.7108 9.87751 18.9508 10.184 19.1258 10.5218C19.217 10.6987 19.1946 10.8585 19.1478 10.9415Z" stroke="currentColor" stroke-width="0.2" mask="url(#path-1-outside-1)"/>
                      </svg>

                      {{__('Vk')}}
                    </v-list-item-title>
                  </v-list-item>
                </a>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div class="title-text">
          <router-link class="news-text__title" :to="{name: 'blog', params: {'page': item.url, lang: $store.getters.getLang}}">{{item.title}}</router-link>
        </div>
        <p class="description">{{item.description}}</p>

        <div class="footer-wrap">
          <span class="block-date">
             <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.06176 6.26949H12.9444" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.96138 8.8731H9.96756" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.00308 8.8731H7.00925" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.03859 8.8731H4.04477" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.96138 11.4641H9.96756" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.00308 11.4641H7.00925" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.03859 11.4641H4.04477" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.69582 1.33331V3.52717" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.31034 1.33331V3.52717" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82551 2.38611H4.18064C2.22285 2.38611 1 3.47673 1 5.48146V11.5146C1 13.5508 2.22285 14.6666 4.18064 14.6666H9.81933C11.7833 14.6666 13 13.5697 13 11.565V5.48146C13.0062 3.47673 11.7895 2.38611 9.82551 2.38611Z"  stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
            <p>{{date}}</p>
          </span>

          <div class="block-author">{{__('By')}}
            <router-link :to="{name: 'blogs_category', params: {'type': 'author', 'name': item.author, lang: $store.getters.getLang}}" v-if="item.author">{{item.author}}</router-link>
            <router-link :to="{name: 'blogs_category', params: {'type': 'author', 'name': 'MINDPLAYS', lang: $store.getters.getLang}}" v-else href="/">MINDPLAYS</router-link>
          </div>
        </div>
      </div>
    </div>
<!--    <ItemShare></ItemShare>-->
  </div>
</template>

<script>
  import moment from "moment";
  import 'moment/locale/ru';
  // import ItemShare from "@/components/pages/Blog/ItemShare";
export default {

  data () {
    return {
      date: null,
      // categoryItem: null,
    }
  },
  props: {
    item: {
      type: Object,
    },
    sorting: {
      type: Object,
    },
    filter: {
      type: Array,
    }
  },

  methods: {
    pushCategory() {
      let sorting = {
        category_id: [this.item.category_id],
      }
      this.$emit("update:sorting", sorting);
      let count = [];
      count.push(this.item.category_id);
      this.$emit('update:filter', count);
    }
  },

  computed: {
    languages() {
      return this.$store.state.language.lang;
    },
  },

  watch: {
    languages(val) {
      if (val == 'ru') {
        this.date = (this.item.created_at) ? moment(this.item.created_at).locale('ru').format('ll') : null
      } else {
        this.date = (this.item.created_at) ? moment(this.item.created_at).locale('en').format('ll') : null
      }
    }
  },

  mounted() {
    if (this.languages == 'ru') {
      this.date = (this.item.created_at) ? moment(this.item.created_at).locale('ru').format('ll') : null
    } else {
      this.date = (this.item.created_at) ? moment(this.item.created_at).locale('en').format('ll') : null
    }
  },

  // computed : {
  //   CategoryName
  // },

  // created() {
  //   let category_id = this.item.category_id;
  //   const category = this.category.find(function (category) {
  //     return category.id == category_id
  //   })
  //   this.categoryItem = category;
  // },
  components: {
    // ItemShare
  }
};
</script>

<style lang="scss" scoped>
  .block-news .news-text .footer-wrap .block-date svg{
    stroke: #002b50;
  }
  .block-news .news-text__head .block-views svg{
    fill: #2A2A2A;
  }

  .dark .block-news .news-text__head .block-views span{
    color: #ffffff;
  }
  .dark .block-news .news-text__head .block-views svg{
    fill: #ffffff;
  }
  .dark .wrap-blog-item{
    background-color: #171827;
  }
  .dark .block-news .news-text__head .v-btn.btn-link{
    color: #ffffff!important;
  }
  .dark .block-news .news-text .footer-wrap .block-date svg{
    stroke: #6886AF;
  }

  .dark .block-news .news-text .title-text a{
    color: #ffffff;
  }
  .dark .block-news .news-text .footer-wrap .block-date p{
    color: #6886AF;
    margin-top: 0;
  }
  .dark .block-news .news-text .footer-wrap .block-author{
    color: #6886AF;
    opacity: 1;
  }
  .dark .block-news .news-text .footer-wrap .block-author a{
    color: #6886AF;
  }
.wrap-blog-item {
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: #fff;
  transition-duration: .3s;
  position: relative;
  width: 100%;

  &:hover {
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.07);
    transition-duration: .3s;

    .block-news {
      border-color: transparent;
      transition-duration: .3s;
    }
    .news-text .title-text {
      color: #26A9F4;
      transition-duration: .3s;
    }
  }
}

a {
  text-decoration: none;
  z-index: -1;
}
.block-news {
  display: flex;
  transition-duration: .3s;
  position: relative;
  height: 270px;

  .news-img {
    margin-right: 20px;
    min-width: 50%;
    height: 230px;
    border-radius: 10px;
    background-size: cover;
    background-position: center;
    position: relative;
    z-index: 1;

    img {
      display: block;
      border-radius: 4px;
    }
  }

  .news-text {
    width: 100%;
    padding: 0px 0px 20px 0;

    &__head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      margin-top: -9px;
      margin-right: -20px;

      .block-category {
        font-weight: 400;
        text-transform: capitalize;
        font-size: 14px;
        line-height: 210%;
        letter-spacing: 0.02em;
        color: #00AEFF;

        a {
          color: #00AEFF;
        }
      }

      .block-views {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: 12px;
          margin-left: 5px;
          cursor: default;
        }
      }

      .v-btn.btn-link {
        color: #002b50!important;

        &:hover {
          color: #0F9AFF!important;
        }
      }

      .v-btn.btn-link.v-btn:not(.v-btn--round).v-size--default {
        padding: 0 20px 20px;
        min-width: auto;
        margin-bottom: -20px;
      }
    }

    .title-text {
      font-size: 24px;
      line-height: 28px;
      color: #002B50;
      // white-space: nowrap;
      overflow: hidden;
      // text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 12px;
      transition-duration: .3s;

      a {
        color: #002b50;
      }
    }

    .description {
      height: 102px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #96AFD1;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      margin-bottom: 5px;
    }

    .footer-wrap {
      display: flex;
      align-items: center;

      .block-date {
        display: flex;
        align-items: center;
        margin-right: 25px;

        p {
          font-weight: 400;
          font-size: 13px;
          line-height: 21px;
          color: #002b50;
          margin: 2px 0 0 9px;
        }
      }

      .block-author {
        font-size: 13px;
        line-height: 165%;
        color: #4D6B85;
        opacity: 0.7;

        a {
          color: #4D6B85;

          &:hover {
            color: #26A9F4;
            text-decoration: underline;
          }
        }
      }
    }
  }
}


.v-menu__content {
  margin-top: -5px;
}

.dark {
  .list-socials {
    p {
      color: #fff;
    }

    .v-list-item {

      &:hover {
        background: #2B2B2B;
      }

      &__title {
        color: #96AFD1;
      }

      svg {
        color: #96AFD1;
      }
    }
  }
}

  .list-socials {
    width: 230px;

    p {
      margin: 4px 0 12px 14px;
    }

    .v-list-item {

      &:hover {
        background-color: #F1F2F8;

          svg {
            color: #26a9f4;
          }

        .v-list-item__title {
          color: #26a9f4;
        }
      }

      &__title {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #6886AF;

        svg {
          margin-right: 12px;
        }
      }
    }
  }

@media screen and (max-width: 950px){
  .block-news {
    height: 220px;
    .news-img {
      min-width: 50%;
      height: auto;
    }

    .news-text {
      &__head {
        margin-bottom: 6px;
      }

      .description {
        height: 62px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
      }
    }
  }
}

@media screen and (max-width: 800px){
  .block-news {
    height: 200px;
    .news-img {
      /*min-width: 320px;*/
      /*height: 200px;*/
      margin-right: 16px;
    }

    .news-text {
      &__head {
        margin-bottom: 6px;
      }

      .title-text {
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 8px;
      }

      .description {
        height: 62px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .wrap-blog-item {
    display: none;
  }
}
</style>